import styled from "styled-components";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

import { formatPriceWithSymbol, formatPrice } from '../../utils/currency';
import regionConfig from '../../config/regionConfig';
import InputMoney from "../ListItem/InputMoney";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import { v4 as uuidv4 } from 'uuid';

const DivPedidoContainer = styled.div`
  z-index:115;
  position: fixed;
  top: 0;
  left: 0;
  display: ${({ showModalPagamentos }) => (showModalPagamentos ? 'none' :'flex' )};
  float: left;
  min-width: 100%;
  min-height: 100%;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  padding: 5px 0;
  list-style: none;
  background-color: rgba(0,0,0,0.5);
  background-clip: padding-box;
  align-items:center;
  justify-content:center;
  opacity: ${({ showModalPagamentos }) => (showModalPagamentos ? '0' :'1' )};
  transition: opacity .3s ease-in-out;

  // Add keyframes for the fade-in effect
  animation: fadeIn .3s ease-in-out;
  animation-fill-mode: forwards;

  // Define the keyframes for the animation
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const DivPedido = styled.div`
    z-index:120;
    position: absolute;
    top: 10%;
    left: 20%;
    float: left;
    min-width: 60%;
    min-height: 15%;
    max-width: 60%;
    padding: 5px 0;
    list-style: none;
    --background-color: white;
    background-color:rgb(255,255,255)!important;
    background-clip: padding-box;
    border-radius: 15px;
    padding:20px;

`;

const ModalPagamentos = ({
    showModalPagamentos,
    setShowModalPagamentos,
    formaPagamento, 
    setFormaPagamento,
    selectedPayment,
    setSelectedPayment,
    selectedCliente,
    setSelectedCliente,
    selectedAddress,
    setSelectedAddress,
    empresa,
    subTotal,
    valorTotal,
    savedFormaEntrega,
    onPaymentConfirmed
}) => {
    const { t } = useTranslation('pdv');

    // Tipos aceitos no pagamento dividido. Lista e nao ternario: antes isto era
    // `toogle === 'cash' ? money : card`, entao QUALQUER tipo novo virava "Cartao"
    // em silencio. Com a lista, incluir um quarto tipo nao exige reescrever
    // condicional nenhuma.
    // PIX segue o mesmo gate de regiao da aba PIX do modo simples: no Libano
    // (`regionConfig.features.pix === false`) o botao nao existe.
    const TIPOS_DIVIDIDO = [
        { chave: 'cash', rotulo: () => t('payment.money'), temTroco: true, disponivel: true },
        { chave: 'card', rotulo: () => t('payment.card'), temTroco: false, disponivel: true },
        { chave: 'pix', rotulo: () => t('payment.pix'), temTroco: false, disponivel: !!regionConfig.features.pix },
    ];
    const tiposDivididoAtivos = TIPOS_DIVIDIDO.filter((x) => x.disponivel);
    const acharPorChave = (chave) => TIPOS_DIVIDIDO.find((x) => x.chave === chave) || null;

    const rotuloDoTipo = (chave) => {
        const achado = acharPorChave(chave);
        return achado ? achado.rotulo() : null;
    };
    // Devolve null quando o rotulo nao casa com tipo nenhum (lancamento antigo,
    // idioma trocado no meio). Melhor o operador reescolher do que o sistema
    // reclassificar o dinheiro sozinho.
    const tipoDoRotulo = (rotulo) => {
        const achado = TIPOS_DIVIDIDO.find((x) => x.rotulo() === rotulo);
        return achado ? achado.chave : null;
    };
    const tipoTemTroco = (chave) => !!(acharPorChave(chave) || {}).temTroco;

    const [valorTroco, setValorTroco] = useState(0);
    const [lancamentoDivididoToogle, setLancamentoDivididoToogle] = useState(null); // chave de TIPOS_DIVIDIDO
    const [valueToPay, setValueToPay] = useState(0);
    const [valorTrocoDividido, setValorTrocoDividido] = useState(0);
    const [pagamentosDivididos, setPagamentosDivididos] = useState([]);
   
    const closeModalPagamentos = () => {
        setShowModalPagamentos(!showModalPagamentos);
    }

    const handleChangePaymentType = (paymentType) => {
        setFormaPagamento(paymentType);
        setSelectedPayment(null);
        if (paymentType !== 'Dividido') {
            setPagamentosDivididos([]);
        }        
    }

    const handleToogleLancamentoDividido = (type) => {
        setLancamentoDivididoToogle(type);
        setValueToPay(parseFloat(calculaValorRestante().replace(',','.')));
    }

    const handleAddDividedPayment = () => {
        if (valueToPay <= 0) {
            toast(t('payment.errors.valueZero'), { autoClose: 3000, type: 'warning' });
            return;
        }

        const totalDivided = pagamentosDivididos.reduce((sum, payment) => sum + payment.value, 0);


        if (totalDivided + valueToPay > valorTotal) {
            toast(t('payment.errors.exceedsTotal'), { autoClose: 3000, type: 'warning' });
            return;
        }

        if (tipoTemTroco(lancamentoDivididoToogle) && valorTrocoDividido <= valueToPay && valorTrocoDividido !== 0) {
            toast(t('payment.errors.changeGreaterThanValue'), { autoClose: 3000, type: 'warning' });
            return;
        }
        const type = rotuloDoTipo(lancamentoDivididoToogle);
        // Sem tipo selecionado nao ha o que lancar. Antes isto era impossivel de
        // atingir porque o campo de valor so existia com um tipo escolhido; com a
        // lista de tipos o guard fica explicito em vez de implicito.
        if (!type) {
            toast(t('payment.selectMethod'), { autoClose: 3000, type: 'warning' });
            return;
        }
        const newPayment = {
            id: uuidv4(),
            // `type` e o rotulo traduzido, usado so para exibir. `tipo` e a chave
            // estavel que viaja para o backend e vira lancamento de caixa -- rotulo
            // traduzido nunca pode virar dado persistido.
            tipo: lancamentoDivididoToogle,
            type: type,
            value: valueToPay,
            troco: tipoTemTroco(lancamentoDivididoToogle) && valorTrocoDividido > 0 ? valorTrocoDividido : t('payment.noChange'),
        };

        // process.env.REACT_APP_ISDEVELOP === 'true' && console.debug('valorTrocoDividido', valorTrocoDividido)

        setPagamentosDivididos([...pagamentosDivididos, newPayment]);
        setSelectedPayment({
            paymentType: 'Dividido',
            pagamentosDivididos: [...pagamentosDivididos, newPayment],
        });

        setLancamentoDivididoToogle(null);
        setValueToPay(0);
        setValorTrocoDividido(0);
    }

    const handleRemoveDividedPayment = (index) => {
        const updatedPayments = pagamentosDivididos.filter((_, i) => i !== index);
        setPagamentosDivididos(updatedPayments);
        setSelectedPayment(updatedPayments.length > 0 ? {
            paymentType: 'Dividido',
            pagamentosDivididos: updatedPayments,
        } : null);
    }

    const handleEditDividedPayment = (index) => {
        const paymentToEdit = pagamentosDivididos[index];
        // process.env.REACT_APP_ISDEVELOP === 'true' && console.debug('paymentToEdit', paymentToEdit);

        // Prefere a chave; cai no rotulo so para lancamentos feitos antes dela existir.
        const typeToogle = paymentToEdit.tipo || tipoDoRotulo(paymentToEdit.type);
        setLancamentoDivididoToogle(typeToogle);
        setValueToPay(paymentToEdit.value);
        setValorTrocoDividido(paymentToEdit.troco === t('payment.noChange') ? 0 : paymentToEdit.troco);
        handleRemoveDividedPayment(index);
    }

    const handleRemovePayment = () => {
        setSelectedPayment(null);
        setValorTroco(0);
    }

    const calculaValorRestante = () => {
        const totalDivided = pagamentosDivididos.reduce((sum, payment) => sum + payment.value, 0);
        const totalPaid = formaPagamento !== 'Dividido' && selectedPayment ? selectedPayment.valorPago : totalDivided;
        return Math.max(0, valorTotal - totalPaid).toFixed(2).toString().replace('.', ',');
    }


    const calculaValorTroco = () => {
        const totalDividedTroco = pagamentosDivididos
            .filter(payment => payment.type === t('payment.money') && payment.troco !== t('payment.noChange'))
            .reduce((sum, payment) => payment.troco - payment.value, 0);
            // process.env.REACT_APP_ISDEVELOP === 'true' && console.debug('totalDividedTroco', totalDividedTroco);
            // process.env.REACT_APP_ISDEVELOP === 'true' && console.debug('selectedPayment.valorTroco', selectedPayment?.valorTroco - valorTotal);
        const totalSingleTroco = selectedPayment && selectedPayment.paymentType === 'Dinheiro' ? selectedPayment.valorTroco - valorTotal : 0;
        // process.env.REACT_APP_ISDEVELOP === 'true' && console.debug('calc troco', Math.max(0, totalDividedTroco + totalSingleTroco).toFixed(2).toString().replace('.', ','))
        return Math.max(0, totalDividedTroco + totalSingleTroco).toFixed(2).toString().replace('.', ',');
    }

    const calculaValorTrocoDividido = (pagamento) => {
        // process.env.REACT_APP_ISDEVELOP === 'true' && console.debug('pagamento', pagamento)
        const totalDividedTroco = pagamentosDivididos
            .filter(payment => payment.type === t('payment.money') && payment.troco !== t('payment.noChange') && payment.id === pagamento.id)
            .reduce((sum, payment) => payment.troco - payment.value, 0);
        // Devolve NUMERO. Antes devolvia string formatada em pt-BR ("0,00") e os
        // tres chamadores comparavam contra esse literal -- numa loja USD o valor
        // formatado e "0.00", a comparacao nunca batia e a tela mostrava
        // "Troco para ..." mesmo quando nao havia troco nenhum.
        return Math.max(0, totalDividedTroco);
    }

    // Comparacao com tolerancia em vez de === 0: o valor sai de subtracoes de
    // float e pode chegar como 0.0000001. Meio centavo e o limiar seguro.
    const semTroco = (pagamento) => calculaValorTrocoDividido(pagamento) < 0.005;


    const saveModalPayment = () => {
        if (formaPagamento === "Dinheiro" && valorTroco <= valorTotal && valorTroco !== 0) {
            toast(t('payment.errors.changeGreaterThanTotal'), { autoClose: 3000, type: 'warning' });
            return;
        }
        if ((formaPagamento === "Dinheiro" && valorTroco >= valorTotal) || (formaPagamento === "Dinheiro" && valorTroco === 0)) {
            const payment = { paymentType: formaPagamento, valorTroco, valorPago: valorTotal };
            toast(t('payment.success'), { autoClose: 1000, type: 'success' });
            setSelectedPayment(payment);
            closeModalPagamentos();
            onPaymentConfirmed && onPaymentConfirmed(payment);
        }
        if (formaPagamento === "Cartão" || formaPagamento === "Pix") {
            const payment = { paymentType: formaPagamento, valorTroco: 0, valorPago: valorTotal };
            toast(t('payment.success'), { autoClose: 1000, type: 'success' });
            setSelectedPayment(payment);
            closeModalPagamentos();
            onPaymentConfirmed && onPaymentConfirmed(payment);
        }
        if (formaPagamento === "Dividido") {
            const payment = { paymentType: formaPagamento, pagamentosDivididos };
            toast(t('payment.success'), { autoClose: 1000, type: 'success' });
            setSelectedPayment(payment);
            closeModalPagamentos();
            onPaymentConfirmed && onPaymentConfirmed(payment);
        }
    }




    return (
        <DivPedidoContainer showModalPagamentos={showModalPagamentos}>
            <DivPedido>     
                <div className="divModalEntregaPDV" style={{minHeight:130}}> 
                    <div className="divTitleAndContentModalEntregaPDV">         
                        <div className="closeModalPedido" onClick={() => closeModalPagamentos()}>
                            <div
                                iconname="x"
                                iconcolor="#2B2B2B"
                                iconsize={18}
                                className="iconCancel"
                                style={{ height: 18, display: 'flex' }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={18}
                                    height={18}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#2B2B2B"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-x"
                                >
                                    <line x1={18} y1={6} x2={6} y2={18} />
                                    <line x1={6} y1={6} x2={18} y2={18} />
                                </svg>
                            </div>
                        </div>

                        <h4>{t('payment.modalTitle')}</h4>

                        <div className="divSelectFormaEntregaModal">
                            <div className="divFormaEntrega_1" onClick={() => handleChangePaymentType('Dinheiro')}
                                style={{
                                    background: formaPagamento === "Dinheiro" ? '#1095F3' : '',
                                    color: formaPagamento === "Dinheiro" ? 'white' : ''
                                }}>
                                <span>{t('payment.money')}</span>
                            </div>
                            <div className="divFormaPagamento_meio" onClick={() => handleChangePaymentType('Cartão')}
                                style={{
                                    background: formaPagamento === "Cartão" ? '#1095F3' : '',
                                    color: formaPagamento === "Cartão" ? 'white' : ''
                                }}>
                                <span>{t('payment.card')}</span>
                            </div>
                            {regionConfig.features.pix && (
                            <div className="divFormaPagamento_meio" onClick={() => handleChangePaymentType('Pix')}
                                style={{
                                    background: formaPagamento === "Pix" ? '#1095F3' : '',
                                    color: formaPagamento === "Pix" ? 'white' : ''
                                }}>
                                <span>{t('payment.pix')}</span>
                            </div>
                            )}
                            <div className="divFormaEntrega_2" onClick={() => handleChangePaymentType('Dividido')}
                                style={{
                                    background: formaPagamento === "Dividido" ? '#1095F3' : '',
                                    color: formaPagamento === "Dividido" ? 'white' : ''
                                }}>
                                <span>{t('payment.split')}</span>
                            </div>
                        </div>

                        <div className="divModalFormaPagamentoDinheiro">
                            {calculaValorRestante() === "0,00" && (
                                <div className="contentLeftModalPagamentos">
                                    <div className="divPagamentoSelecionadoContent">
                                        <span>{t('payment.allPaymentsLaunched')}</span>
                                    </div>
                                </div>
                            )}
                            {!selectedPayment && calculaValorRestante() !== "0,00" &&
                                formaPagamento === "Dinheiro" ?
                                    <div className="contentLeftModalPagamentos">
                                        <label style={{ fontWeight: 500 }}>{t('payment.changeFor')}</label>
                                        <div style={{ padding: "0px", width: '100%' }}>
                                            <InputMoney
                                                onChange={(event) => setValorTroco(Number(event.target.value))}
                                                value={valorTroco}
                                                className="inputPersonalizedTroco"
                                                placeholder={t('payment.change')}
                                            />
                                        </div>
                                    </div>
                                    :
                                    formaPagamento === "Dividido" && calculaValorRestante()!=="0,00" ?
                                        <div className="contentLeftModalPagamentos">
                                            <div className="divFormaPagamentoDividido">
                                                {tiposDivididoAtivos.map((tipo) => (
                                                    <button
                                                        key={tipo.chave}
                                                        onClick={() => handleToogleLancamentoDividido(tipo.chave)}
                                                        style={{
                                                            background: lancamentoDivididoToogle === tipo.chave && 'rgb(16, 149, 243)',
                                                            color: lancamentoDivididoToogle === tipo.chave && 'white'
                                                        }}>
                                                        <span>{tipo.rotulo()}</span>
                                                    </button>
                                                ))}
                                            </div>

                                            {/* Um bloco so: o campo de valor serve a qualquer tipo, e o
                                                troco aparece so em quem tem troco. Antes eram dois blocos
                                                identicos (cash e card) -- por isso o PIX apareceria com o
                                                botao aceso e nenhum campo de valor. */}
                                            {lancamentoDivididoToogle &&
                                                <>
                                                    <label style={{ fontWeight: 500 }}>{t('payment.valueToPay')}</label>
                                                    <div style={{ padding: "0px", width: '100%' }}>
                                                        <InputMoney
                                                            onChange={(event) => setValueToPay(Number(event.target.value))}
                                                            value={valueToPay}
                                                            className="inputPersonalizedTroco"
                                                            placeholder={t('payment.change')}
                                                        />
                                                    </div>
                                                    {tipoTemTroco(lancamentoDivididoToogle) &&
                                                        <>
                                                            <label style={{ fontWeight: 500 }}>{t('payment.changeFor')}</label>
                                                            <div style={{ padding: "0px", width: '100%' }}>
                                                                <InputMoney
                                                                    onChange={(event) => setValorTrocoDividido(Number(event.target.value))}
                                                                    value={valorTrocoDividido}
                                                                    className="inputPersonalizedTroco"
                                                                    placeholder={t('payment.change')}
                                                                />
                                                            </div>
                                                        </>
                                                    }
                                                </>
                                            }
                                            <div className="divBtnModalPagLancarDividido">
                                                <button onClick={() => handleAddDividedPayment()}>{t('payment.launchPayment')}</button>
                                            </div>
                                        </div>
                                    : 
                                    !selectedPayment ? (
                                        <div className="contentLeftModalPagamentos">                                            
                                        </div>
                                        )
                                        : null
                            }                                                                                                  
                            <div className="summary-container-modalPagamentos" style={{minWidth:'50%'}}>
                                <div className="summary-item-modalPagamentos">
                                    <span className="label-modalPagamentos">{t('payment.subtotal')}</span>
                                    <span className="value-modalPagamentos">{formatPriceWithSymbol(subTotal)}</span>
                                </div>
                                {savedFormaEntrega?.formaEntrega === "Entrega" &&
                                    <div className="summary-item-modalPagamentos">
                                        <span className="label-modalPagamentos">{t('payment.deliveryFee')}</span>
                                        <span className="value-modalPagamentos">{formatPriceWithSymbol(savedFormaEntrega?.valorEntrega)}</span>
                                    </div>
                                }
                                <div className="summary-item-modalPagamentos total-modalPagamentos">
                                    <span className="label-modalPagamentos">{t('payment.total')}</span>
                                    <span className="value-modalPagamentos">{formatPriceWithSymbol(valorTotal)}</span>
                                </div>

                                {pagamentosDivididos.length === 0 && !selectedPayment && <div className="message-modalPagamentos">{t('payment.launchPayments')}</div>}
                                {pagamentosDivididos.length > 0 &&
                                    <div className="pagamentosLancados-modalPagamentos">
                                        <span>{t('payment.payments')}</span>
                                        <span style={{ fontSize: 9 }}>{t('payment.hoverToEditOrDelete')}</span>                                       
                                        <div className="paiDividido" style={{ marginTop: 5 , width:'100%'}}>
                                            {pagamentosDivididos.map((pagamento, index) => (
                                                <div className="divBorderBottomPaymentDividido" key={index}>
                                                    <div className="lista-pedidos" style={{ /*height: pagamento.type === "Dinheiro" ? 20 : 40,*/ paddingLeft:12 }}> 
                                                        <div className="divFormaPaymentDivididoPai">                                               
                                                            <div className="divFormaPaymentDividido">
                                                                <div style={{ display: 'flex', alignItems: 'start'}}>
                                                                    <span style={{ marginLeft: -10 }}>{index + 1}º</span>
                                                                    <span style={{ marginLeft: 10 }}>{pagamento.type}</span>
                                                                </div>
                                                                <div>
                                                                    {formatPriceWithSymbol(pagamento.value)}
                                                                </div>  
                                                            </div> 
                                                            {pagamento.type === t('payment.money') &&
                                                                <div className="lista-pedidos" style={{ height: 20, paddingLeft:12, width:'100%', justifyContent:'space-between' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'start', justifyContent:'space-between', width:'75%' }}>
                                                                        <span>{semTroco(pagamento) ? t('payment.change') : t('payment.changeForValue', { value: formatPriceWithSymbol(pagamento.troco) })}</span>
                                                                    </div>
                                                                    <div style={{ minWidth: semTroco(pagamento) ? 100 : 52 }}>
                                                                        {semTroco(pagamento) ? t('payment.noChange') : formatPriceWithSymbol(calculaValorTrocoDividido(pagamento))}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="divBtnsEditAndAddObsItem" style={{width:'100px'}}>
                                                            <div style={{ width: '50%', borderRight: '1px solid lightgray' }}>
                                                                <button className="btnEditModalPaymentDividido" onClick={() => handleEditDividedPayment(index)}>{t('payment.edit')}</button>
                                                            </div>
                                                            <div style={{ width: '50%' }}>
                                                                <button className="btnRemoveModalPaymentDividido" onClick={() => handleRemoveDividedPayment(index)}>{t('payment.delete')}</button>
                                                            </div>
                                                        </div>                                     
                                                    </div>                                                    
                                                </div>
                                            ))}
                                            
                                        </div>
                                    </div>
                                }

                                {selectedPayment && !pagamentosDivididos.length &&
                                    <div className="pagamentosLancados-modalPagamentos">
                                        <span>{t('payment.payments')}</span>
                                        <span style={{ fontSize: 9 }}>{t('payment.hoverToEditOrDelete')}</span>
                                        <div className="pai" style={{ marginTop: 5, width:'100%' }}>
                                            <div className="lista-pedidos" style={{ height: 20, paddingLeft:12 }}>
                                                <div style={{ display: 'flex', alignItems: 'start', minWidth: 200 }}>
                                                    <span style={{ marginLeft: -10 }}>1º</span>
                                                    <span style={{ marginLeft: 10 }}>{selectedPayment.paymentType}</span>
                                                </div>
                                                <div style={{ minWidth: 60 }}>
                                                    {formatPriceWithSymbol(selectedPayment.valorPago)}
                                                </div>
                                            </div>
                                            {selectedPayment.paymentType === "Dinheiro" &&
                                                <div className="lista-pedidos" style={{ height: 20, paddingLeft:12 }}>
                                                    <div style={{ display: 'flex', alignItems: 'start', minWidth: 160 }}>
                                                        <span style={{ marginLeft: 10 }}>{calculaValorTroco() ==="0,00" ? t('payment.change') : t('payment.changeForValue', { value: formatPriceWithSymbol(selectedPayment.valorTroco) })}</span>
                                                    </div>
                                                    <div style={{ minWidth: calculaValorTroco()=== "0,00"? 100 : 52 }}>
                                                        {calculaValorTroco()=== "0,00" ? t('payment.noChange') : formatPriceWithSymbol(parseFloat(calculaValorTroco().replace(',', '.')))}
                                                    </div>
                                                </div>
                                            }
                                            <div className="line-separator" />
                                            <div className="divBtnsEditAndAddObsItem">
                                                <div style={{ width: '100%', borderRight: '1px solid lightgray' }}>
                                                    <button className="btnRemoveItemRelative" onClick={() => handleRemovePayment()}>{t('payment.delete')}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {calculaValorRestante() === "0,00" ?
                                    <div className="missing-amount-modalPagamentos" style={{ background: '#28a745' }}>
                                        <div className="summary-item-modalPagamentos total-modalPagamentos"
                                            style={{ justifyContent: 'center', width: '100%', borderBottom: 'none' }}>
                                            <span className="label-modalPagamentos" style={{ color: 'white' }}>{t('payment.totalPaid')}</span>
                                        </div>
                                    </div>
                                    :
                                    <div className="missing-amount-modalPagamentos">
                                        <div className="summary-item-modalPagamentos total-modalPagamentos" style={{ borderBottom: 'none', width: '100%' }}>
                                            <span className="label-modalPagamentos">{t('payment.missing')}</span>
                                            <span className="value-modalPagamentos">{formatPriceWithSymbol(parseFloat(calculaValorRestante().replace(',', '.')))}</span>
                                        </div>
                                    </div>
                                }                                        
                            </div>
                        </div>
                    </div>
                    <div className="divBtnAddFormaEntregaModal"
                        style={{
                            background: (!formaPagamento || (formaPagamento === "Dividido" && calculaValorRestante() !== "0,00")) ? '#bbb' : '',
                            cursor: (!formaPagamento || (formaPagamento === "Dividido" && calculaValorRestante() !== "0,00")) ? 'not-allowed' : ''
                        }}
                    >
                        <button onClick={() => saveModalPayment()} disabled={!formaPagamento || (formaPagamento === "Dividido" && calculaValorRestante() !== "0,00")}
                            style={{
                                background: (!formaPagamento || (formaPagamento === "Dividido" && calculaValorRestante() !== "0,00")) ? '#bbb' : '',
                                cursor: (!formaPagamento || (formaPagamento === "Dividido" && calculaValorRestante() !== "0,00")) ? 'not-allowed' : ''
                            }}
                        >
                            {selectedPayment && calculaValorRestante() === "0,00" ? t('payment.finishPayment') : t('payment.addPaymentMethod')}
                        </button>
                    </div>
                </div>
            </DivPedido>
        </DivPedidoContainer>
    )

}

export default ModalPagamentos;